export default {
    'guest.registration.page_title': 'Sign up for HeadOffice',
    'guest.registration.already_signedup': 'Already have a HeadOffice account?',
    'guest.registration.terms':
        'Yes, I agree to the <a href="https://headoffice.app/about/terms-of-service" class="underline" target="_blank">terms of service</a> and <a href="https://headoffice.app/about/acceptable-use" class="underline" target="_blank">acceptable use</a>.',

    'tenant.label.vanity_url': 'Personalised HeadOffice URL',

    'filter.refresh': 'Refresh',
    'filter.clear': 'Clear Filters',
    'filter.show_filters': 'Show Filters',
    'filter.hide_filters': 'Hide Filters',

    'filter.search': 'Search',
    'filter.empty': 'Looks like there is nothing to be displayed here',
    'filter.date_format': 'YYYY-MM-DD e.g. 2000-06-21',

    'filter.contains': 'Contains',
    'filter.equals': 'Equals',
    'filter.not_equals': 'Does not equal',
    'filter.greater_than': 'Greater than',
    'filter.less_than': 'Less than',
    'filter.greater_than_or_equal': 'Greater than or equal',
    'filter.less_than_or_equal': 'Less than or equal',

    'button.skip': 'Skip',
    'button.stay': 'Stay on page',
    'button.leave': 'Leave Page',
    'button.download': 'Download',
    'button.close': 'Close',
    'button.next': 'Next',
    'button.yes': 'Yes',
    'button.no': 'No',
    'button.continue': 'Continue',
    'button.confirm': 'Confirm',
    'button.remove': 'Remove',
    'button.view_source': 'Source Document',
    'button.bring_current': 'Bring Current',
    'button.retry': 'Retry',
    'button.save': 'Save',

    'error.message.no_custom_exchange_rate': 'No custom exchange rate has been set for selected currencies',

    'report.button.cancel': 'Cancel',
    'report.button.print': 'Print',
    'report.button.generate': 'Generate',
    'button.show_advanced': 'Show advanced',
    'button.add_attribute': 'Add Attribute',
    'button.add_tax': 'Add Tax',

    'label.yes': 'Yes',
    'label.no': 'No',
    'label.balance': 'Balance',
    'label.difference': 'Difference',

    'label.year': 'Year',
    'label.as_at': 'As At',
    'label.currency': 'Currency',
    'label.total_debits': 'Total Debits',
    'label.total_credits': 'Total Credits',
    'label.use_system_exchange_rate': 'Use system rate',
    'label.use_custom_rate': 'Use internal rate',
    'label.use_own_rate': 'Set my own rate',
    'label.credit_applied': 'Credit Applied',
    'label.issue_credit': 'Issue Credit',
    'label.issue_refund': 'Issue Refund',

    'label.unsaved_changes_confirm': 'You have unsaved changes. Would you like to discard them?',
    'label.archive.button': 'Archive',
    'label.close_button': 'Close',
    'label.edit_button': 'Edit',
    'label.delete.button': 'Delete',
    'label.login_to_app_heading': 'Log in to HeadOffice',
    'label.new_to_product': 'New to HeadOffice?',
    'label.product_name': 'HeadOffice',
    'label.sign_up': 'Sign up here',
    'label.or': 'or',
    'label.error': 'Error',
    'label.required_field': 'Required Field',

    'label.cancelled_on': 'Cancelled on',
    'label.refunded_on': 'Refunded on',
    'label.void_reason': 'Reason for voiding',
    'label.current': 'Current',

    'label.month.january': 'January',
    'label.month.february': 'February',
    'label.month.march': 'March',
    'label.month.april': 'April',
    'label.month.may': 'May',
    'label.month.june': 'June',
    'label.month.july': 'July',
    'label.month.august': 'August',
    'label.month.september': 'September',
    'label.month.october': 'October',
    'label.month.november': 'November',
    'label.month.december': 'December',

    'label.period.daily': 'Daily',
    'label.period.weekly': 'Weekly',
    'label.period.monthly': 'Monthly',
    'label.period.quarterly': 'Quarterly',
    'label.period.annually': 'Annually',

    'label.time.year': 'year | years',
    'label.time.month': ' month | months',
    'label.time.day': 'day | days',
    'label.time.second': 'second | seconds',
    'label.time.minute': 'minute | minutes',
    'label.time.hour': 'hour | hours',

    'label.gender.male': 'Male',
    'label.gender.female': 'Female',

    'label.reset': 'Reset',
    'label.search': 'Search',
    'label.from_date': 'From Date',
    'label.to_date': 'To Date',
    'label.all': 'All',

    'label.attachments': 'Attachments',
    'label.drag_and_drop_or_click': 'Drag and drop files here, or click to select',
    'label.uploading': 'Uploading',
    'label.file_name': 'File Name',
    'label.size': 'Size',
    'label.date': 'Date',
    'label.actions': 'Actions',
    'label.confirm_delete': 'Confirm Delete',
    'label.confirm_delete_attachment': 'Are you sure you want to delete this attachment? This action cannot be undone.',
    'label.cancel_button': 'Cancel',
    'label.delete_button': 'Delete',
    'label.download': 'Download',
    'label.delete': 'Delete',
    'label.accepted_file_types': 'JPG, PNG, PDF, CSV, XLS, XLSX (max 24 MB)',
    'label.invalid_file_type': 'Invalid file type: {fileName}. Accepted: jpg, jpeg, png, pdf, csv, xls, xlsx',
    'label.file_too_large': 'File too large: {fileName}. Maximum size is 24 MB.',
    'label.upload_failed': 'Failed to upload {fileName}',
    'label.preview_failed': 'Failed to preview {fileName}',
    'label.download_failed': 'Failed to download {fileName}',
    'label.delete_failed': 'Failed to delete attachment',

    'modal.title.overpayment': 'This is an overpayment',

    'modal.message.cannot_rollback_payment': 'Sorry, we are unable to rollback this payment because the overpayment credit/refund was already used.',
    'modal.message.cannot_void_payment': 'Sorry, we are unable to void this payment because the overpayment credit/refund was already used.',
    'modal.message.cannot_refund_payment': 'Sorry, we are unable to refund this payment. It may already be refunded or voided, have been paid using available credit, or already have a credit memo.',

    'message.credit_exceeded': 'Your total payment is more than your available credit',
    'message.no_bank_account': 'There are no bank accounts for your selection',
    'message.select_one': 'Please select one',
    'message.not_applicable': 'Not Applicable',
    'message.account_activation_link': 'Please check your email for activation link.',

    'message.search.no-results': 'The content you are looking for was not found. Please try another search!',
    'message.search.nothing-created': "You haven't created anything yet.",
    'message.search.nothing-binned': "You haven't deleted anything yet.",
    'message.search.nothing-archived': "You haven't archived anything yet.",

    'link.learn_more': 'learn more',

    // Validation Begin
    'validation.accepted': 'The {attribute} must be accepted.',
    'validation.active_url': 'The {attribute} is not a valid URL.',
    'validation.after': 'The {attribute} must be a date after {date}.',
    'validation.after_or_equal': 'The {attribute} must be a date after or equal to {date}.',
    'validation.alpha': 'The {attribute} may only contain letters.',
    'validation.alpha_dash': 'The {attribute} may only contain letters, numbers, dashes and underscores.',
    'validation.alpha_num': 'The {attribute} may only contain letters and numbers.',
    'validation.array': 'The {attribute} must be an array.',
    'validation.before': 'The {attribute} must be a date before {date}.',
    'validation.before_or_equal': 'The {attribute} must be a date before or equal to {date}.',

    'validation.between.numeric': 'The {attribute} must be between {min} and {max}.',

    'validation.between.file': 'The {attribute} must be between {min} and {max} kilobytes.',

    'validation.between.string': 'The {attribute} must be between {min} and {max} characters.',

    'validation.between.array': 'The {attribute} must have between {min} and {max} items.',

    'validation.boolean': 'The {attribute} field must be true or false.',
    'validation.confirmed': 'The {attribute} confirmation does not match.',
    'validation.date': 'The {attribute} is not a valid date.',
    'validation.date_equals': 'The {attribute} must be a date equal to {date}.',
    'validation.date_format': 'The {attribute} does not match the format {format}.',
    'validation.different': 'The {attribute} and {other} must be different.',
    'validation.digits': 'The {attribute} must be {digits} digits.',
    'validation.digits_between': 'The {attribute} must be between {min} and {max} digits.',
    'validation.dimensions': 'The {attribute} has invalid image dimensions.',
    'validation.distinct': 'The {attribute} field has a duplicate value.',
    'validation.email': 'The {attribute} must be a valid email address.',
    'validation.ends_with': 'The {attribute} must end with one of the following {values}.',
    'validation.exists': 'The selected {attribute} is invalid.',
    'validation.extensions': 'The {attribute} must have one of the following extensions: {values}.',
    'validation.file': 'The {attribute} must be a file.',
    'validation.filled': 'The {attribute} field must have a value.',

    'validation.gt.numeric': 'The {attribute} must be greater than {value}.',
    'validation.gt.file': 'The {attribute} must be greater than {value} kilobytes.',
    'validation.gt.string': 'The {attribute} must be greater than {value} characters.',
    'validation.gt.array': 'The {attribute} must have more than {value} items.',

    'validation.gte.numeric': 'The {attribute} must be greater than or equal {value}.',
    'validation.gte.file': 'The {attribute} must be greater than or equal {value} kilobytes.',
    'validation.gte.string': 'The {attribute} must be greater than or equal {value} characters.',
    'validation.gte.array': 'The {attribute} must have {value} items or more.',

    'validation.image': 'The {attribute} must be an image.',
    'validation.in': 'The selected {attribute} is invalid.',
    'validation.in_array': 'The {attribute} field does not exist in {other}.',
    'validation.integer': 'The {attribute} must be an integer.',
    'validation.ip': 'The {attribute} must be a valid IP address.',
    'validation.ipv4': 'The {attribute} must be a valid IPv4 address.',
    'validation.ipv6': 'The {attribute} must be a valid IPv6 address.',
    'validation.json': 'The {attribute} must be a valid JSON string.',

    'validation.lt.numeric': 'The {attribute} must be less than {value}.',
    'validation.lt.file': 'The {attribute} must be less than {value} kilobytes.',
    'validation.lt.string': 'The {attribute} must be less than {value} characters.',
    'validation.lt.array': 'The {attribute} must have less than {value} items.',

    'validation.lte.numeric': 'The {attribute} must be less than or equal {value}.',
    'validation.lte.file': 'The {attribute} must be less than or equal {value} kilobytes.',
    'validation.lte.string': 'The {attribute} must be less than or equal {value} characters.',
    'validation.lte.array': 'The {attribute} must not have more than {value} items.',

    'validation.max.numeric': 'This is a little too big, should not be no more than {max}.',
    'validation.max.file': 'The {attribute} may not be greater than {max} kilobytes.',
    'validation.max.string': 'The {attribute} may not be greater than {max} characters.',
    'validation.max.array': 'The {attribute} may not have more than {max} items.',

    'validation.mimes': 'The {attribute} must be a file of type {values}.',
    'validation.mimetypes': 'The {attribute} must be a file of type {values}.',

    'validation.min.numeric': 'The {attribute} must be at least {min}.',
    'validation.min.file': 'The {attribute} must be at least {min} kilobytes.',
    'validation.min.string': 'The {attribute} must be at least {min} characters.',
    'validation.min.array': 'The {attribute} must have at least {min} items.',

    'validation.not_in': 'The selected {attribute} is invalid.',
    'validation.not_regex': 'The {attribute} format is invalid.',
    'validation.numeric': 'The {attribute} must be a number.',
    'validation.password': 'The password is incorrect.',
    'validation.present': 'The {attribute} field must be present.',

    // Both rules are enforced by the client portal's filing-approval endpoints —
    // `prohibited` for a search key the search does not implement, `prohibited_if`
    // for a rejection reason sent alongside an approval — and a key with no entry
    // here resolves to itself, which puts `validation.prohibited` in front of a
    // reader instead of a sentence.
    'validation.prohibited': 'The {attribute} field is prohibited.',
    'validation.prohibited_if': 'The {attribute} field is prohibited when {other} is {value}.',

    'validation.regex': 'The {attribute} format is invalid.',
    'validation.required': "Oops, {attribute} can't be left blank.",
    'validation.nullable': 'The {attribute} field is optional.',
    'validation.required_if': "Oops, {attribute} can't be left blank.",
    'validation.required_unless': 'The {attribute} field is required unless {other} is {values}.',
    'validation.required_with': "Oops, {attribute} can't be left blank.",
    'validation.required_with_all': 'The {attribute} field is required when {values} are present.',
    'validation.required_without': 'The {attribute} field is required when {values} is not present.',
    'validation.required_without_all': 'The {attribute} field is required when none of {values} are present.',
    'validation.same': 'The {attribute} and {other} must match.',

    'validation.size.numeric': 'The {attribute} must be {size}.',
    'validation.size.file': 'The {attribute} must be {size} kilobytes.',
    'validation.size.string': 'The {attribute} must be {size} characters.',
    'validation.size.array': 'The {attribute} must contain {size} items.',

    'validation.starts_with': 'The {attribute} must start with one of the following {values}.',
    'validation.string': 'The {attribute} must be a string.',
    'validation.timezone': 'The {attribute} must be a valid zone.',
    'validation.unique': 'The {attribute} has already been taken.',
    'validation.uploaded': 'The {attribute} failed to upload.',
    'validation.url': 'The {attribute} format is invalid.',
    'validation.uuid': 'The {attribute} must be a valid UUID.',

    'validation.plaintext': 'The {attribute} must be plain text.',
    'validation.discount': 'Value must not be greater than item total.',
    'validation.either_debit_or_credit': 'A debit or credit amount is required',
    'validation.positive_number': 'This value must be a positive number',
    'validation.2mb_file': 'The file size must not exceed 2MB',
    'validation.after_close_date': "The date must be after book's closing date",
    'validation.in_pension_range': 'Value must be between 0% - 10%',
    'validation.less_than_or_equal': 'The value must be less than or equal to {value}.',

    'validation.exact_non_cash_payment': 'You can only pay the exact amount owed with this payment method.',
    'validation.cannot_be_less_than_balance': 'Cannot pay less than the balance owed.',
    'validation.inventory_available': '{value} items(s) available',
    // wp-38 (sales-order-entry-level): "there is some, and it is spoken for" is a different
    // situation from "there is none" — the remedy is a release, not a purchase. Names the
    // holding order(s) so the refusal at the counter is actionable.
    'validation.inventory_reserved': 'Only {value} available to sell — the rest is being held for sales order(s) {orders}. Release the reservation, or choose a different item.',
    'validation.invalid.coupon': 'Invalid or expired coupon',

    // Validation End
    'validation.notification.errors': 'Before we can save, please make corrections to the information you have entered below.',
    'validation.notification.400': 'Looks like you have errors in what you have entered, please correct and try again',

    'welcome.greeting': 'Hello {name}!',

    'organization.organizations': 'Organizations',
    'organization.create_organization': 'Add My Organization',
    'organization.sample_company': 'Sample Company',
    'organization.search_organizations': 'Search organizations',
    'organization.search_empty': 'No organizations match your search.',
    'organization.clear_search': 'Clear search',

    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'pagination.results': 'Showing <strong>{from}</strong> to <strong>{to}</strong> of <strong>{total}</strong> results',
    'pagination.page': 'Page {current} of {total}',
    'navigation.modal.title': 'Leaving Page?',
    'navigation.modal.message': 'Changes that you made to this page may not be saved.',

    'new_version.modal.title': 'A new version is available',
    'new_version.modal.message': 'HeadOffice has been updated. Please reload your browser to continue using the application.',
    'new_version.modal.reload_button': 'Reload now',

    'generic.grand.total': 'Grand Total',

    'placeholder.select_date': 'Select date',
};
